import { apiFetch } from '@nrdy-marketing-engine/api-fetch';

const fetchCart = (cartId?: string) => apiFetch(`/v1/carts/${cartId}`);

export default fetchCart;
